module.exports = __webpack_public_path__ + "img/1548198051.7482cc76.jpg";